import client1 from "../../assets/img/client/client-1.avif";
import client2 from "../../assets/img/client/hpcl.webp";
import client3 from "../../assets/img/client/iocl.jpg";
import client4 from "../../assets/img/client/indore.png";
import client5 from "../../assets/img/client/NUPPL.jpg";
import client6 from "../../assets/img/client/RCF.jpg";
import client7 from "../../assets/img/client/CPCL.jpg";
import client8 from "../../assets/img/client/pwd.webp";
import client9 from "../../assets/img/client/bhiwadi.jpg";
import client10 from "../../assets/img/client/indian-railway.png";
import client11 from "../../assets/img/client/adani.jpg";
import client12 from "../../assets/img/client/sonalika.jpg";
import client13 from "../../assets/img/client/epsilon.jpg";
import client14 from "../../assets/img/client/JSWSTEEL.webp";
import client15 from "../../assets/img/client/nbcc.jpg";

import clientOld1 from "../../assets/img/client/client1.PNG";
import clientOld2 from "../../assets/img/client/client2.PNG";
import clientOld3 from "../../assets/img/client/client3.PNG";
import clientOld4 from "../../assets/img/client/client4.PNG";

function Clients({ t }) {
  return (
    <>
      <section className="faqSec sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mb-3">
              <div className="faqInfo">
                <div className="fisherman-content">
                  <h6>{t("Clients")}</h6>
                  <h3>{t("Our Clients")}</h3>
                </div>
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client1} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client2} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client3} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client4} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client5} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client6} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client7} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client8} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client9} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client10} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client11} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client12} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client13} alt="clients" className="img-fluid" />
                  </div>

                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client14} alt="clients" className="img-fluid" />
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-4 col-xs-6">
                    <img src={client15} alt="clients" className="img-fluid" />
                  </div>

                  <div className="col-lg-12">
                    <img
                      src={clientOld1}
                      alt="clients"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="col-lg-12">
                    <img
                      src={clientOld2}
                      alt="clients"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="col-lg-12">
                    <img
                      src={clientOld3}
                      alt="clients"
                      className="img-fluid w-100"
                    />
                  </div>
                  <div className="col-lg-12">
                    <img
                      src={clientOld4}
                      alt="clients"
                      className="img-fluid w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Clients;
